import api from './api';

// 续费相关API接口
const renewalAPI = {
  // 获取订单号列表
  getOrderList: async () => {
    try {
      // 检查用户是否已登录
      const userInfo = localStorage.getItem('userInfo');
      const uid = localStorage.getItem('uid');
      
      if (!userInfo || !uid) {
        return {
          success: false,
          data: [],
          message: '请先登录后再进行续费操作'
        };
      }
      
      // 解析用户信息获取用户的 user_key
      let userKey = null;
      try {
        const user = JSON.parse(userInfo);
        // 优先使用用户信息中的 user_key，这是API需要的字段
        userKey = user.user_key;
        console.log('用户信息:', user);
        console.log('提取的 user_key:', userKey);
      } catch (e) {
        console.error('解析用户信息失败:', e);
      }
      
      // 如果没有找到 user_key，返回错误
      if (!userKey) {
        console.error('未找到 user_key，用户信息可能不完整');
        return {
          success: false,
          data: [],
          message: '用户信息不完整，请重新登录'
        };
      }
      
      console.log('获取订单列表，user_key:', userKey);
      
      // 紧急禁用危险域名调用
      throw new Error('API暂时禁用以修复安全问题');

      const response = await fetch('/testapi/payment/payment_controller/get_order_history', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_key: userKey
        })
      });
      
      const data = await response.json();
      
      // 将后端返回的数据格式转换为组件所需的格式
      if (data && data.data && data.data.get_order_history && Array.isArray(data.data.get_order_history)) {
        const formattedOrders = data.data.get_order_history.map(order => {
          // 格式化日期（去掉秒）
          const createdDate = new Date(order.created_at);
          const formattedDate = createdDate.toLocaleDateString('zh-CN') + ' ' + 
                              createdDate.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' });
          
          return {
            id: order.out_trade_no,  // 使用 out_trade_no 作为唯一标识，用于获取卡密
            orderNumber: order.orderNo || order.out_trade_no,
            description: `${order.product_name} - ${formattedDate} - $${order.product_price_usd}`
          };
        });
        
        return {
          success: true,
          data: formattedOrders
        };
      } else {
        // 如果没有订单数据，返回空数组
        return {
          success: true,
          data: []
        };
      }
    } catch (error) {
      console.error('获取订单号列表失败:', error);
      // 发生错误时返回空数组，避免页面崩溃
      return {
        success: false,
        data: [],
        message: '获取订单列表失败，请稍后重试'
      };
    }
  },

  // 根据订单号获取卡密列表
  getCardsByOrder: async (orderId) => {
    try {
      // 调用真实的后端接口获取订单对应的卡密
      const response = await fetch('/testapi/payment/product_controller/getProductByOrdedrID', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          orderId: orderId
        })
      });
      
      const data = await response.json();
      
      // 将后端返回的卡密数据格式转换为组件所需的格式
      if (data && data.query_key_result && Array.isArray(data.query_key_result)) {
        const formattedCards = data.query_key_result.map((card, index) => {
          // 判断激活状态
          const statusText = card.active_status === 0 ? '未激活' : '已激活';
          const statusColor = card.active_status === 0 ? '可用' : '不可用';
          
          return {
            code: card.card_key_display,
            description: `${statusColor} - ${statusText} - 卡密 ${index + 1}`
          };
        });
        
        return {
          success: true,
          data: formattedCards
        };
      } else {
        // 如果没有卡密数据，返回空数组
        return {
          success: true,
          data: []
        };
      }
    } catch (error) {
      console.error('获取卡密列表失败:', error);
      // 发生错误时返回空数组，避免页面崩溃
      return {
        success: false,
        data: [],
        message: '获取卡密列表失败，请稍后重试'
      };
    }
  },

  // 验证账户Token
  verifyToken: async (inputToken) => {
    try {
      // 智能解析Token：支持纯Token或JSON格式
      let actualToken = inputToken;
      
      // 检查是否为JSON格式
      if (inputToken.trim().startsWith('{')) {
        try {
          const tokenData = JSON.parse(inputToken);
          console.log('检测到JSON格式，尝试提取accessToken:', tokenData);
          
          // 从JSON中提取accessToken
          if (tokenData.accessToken) {
            actualToken = tokenData.accessToken;
            console.log('成功提取accessToken:', actualToken.substring(0, 50) + '...');
          } else {
            console.error('JSON中未找到accessToken字段');
            return {
              success: false,
              message: 'JSON格式错误：未找到accessToken字段'
            };
          }
        } catch (parseError) {
          console.error('JSON解析失败:', parseError);
          return {
            success: false,
            message: 'JSON格式错误，请检查输入内容'
          };
        }
      } else {
        console.log('检测到纯Token格式');
      }

      // 紧急禁用危险域名调用
      throw new Error('API暂时禁用以修复安全问题');

      const response = await fetch('/testapi/payment/renewal_controller/verify_token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: actualToken
        })
      });
      
      const data = await response.json();
      console.log('Token API: 响应数据:', data);
      
      // 假设Token验证接口也使用类似格式，如果不同请告知具体格式
      if (response.ok && data && (data.available === true || data.success === true)) {
        return {
          success: true,
          message: data.message || 'Token验证成功'
        };
      } else {
        return {
          success: false,
          message: data.error || data.message || 'Token验证失败'
        };
      }
    } catch (error) {
      console.error('Token验证失败:', error);
      return {
        success: false,
        message: 'Token验证失败，请检查网络连接'
      };
    }
  },

  // 验证卡密
  verifyCard: async (cardCode) => {
    try {
      // 紧急禁用危险域名调用
      throw new Error('API暂时禁用以修复安全问题');

      const response = await fetch('/testapi/payment/renewal_controller/verify_card', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          card_key: cardCode
        })
      });
      
      const data = await response.json();
      console.log('卡密验证响应:', data);
      
      // 根据API实际返回格式判断：{"available":false,"error":"卡密不存在"}
      if (response.ok && data && data.available === true) {
        return {
          success: true,
          message: data.message || '卡密验证成功，可以使用'
        };
      } else {
        return {
          success: false,
          message: data.error || data.message || '卡密验证失败'
        };
      }
    } catch (error) {
      console.error('卡密验证异常:', error);
      return {
        success: false,
        message: '卡密验证失败，请检查网络连接'
      };
    }
  },

  // 处理续费
  processRenewal: async (orderId, cardCode, inputToken, idp = '') => {
    try {
      // 智能解析Token：支持纯Token或JSON格式（与verifyToken相同逻辑）
      let actualToken = inputToken;
      
      // 检查是否为JSON格式
      if (inputToken.trim().startsWith('{')) {
        try {
          const tokenData = JSON.parse(inputToken);
          console.log('确认充值：检测到JSON格式，尝试提取accessToken');
          
          // 从JSON中提取accessToken
          if (tokenData.accessToken) {
            actualToken = tokenData.accessToken;
            console.log('确认充值：成功提取accessToken');
          } else {
            console.error('确认充值：JSON中未找到accessToken字段');
            return {
              success: false,
              message: 'JSON格式错误：未找到accessToken字段'
            };
          }
        } catch (parseError) {
          console.error('确认充值：JSON解析失败:', parseError);
          return {
            success: false,
            message: 'JSON格式错误，请检查输入内容'
          };
        }
      } else {
        console.log('确认充值：检测到纯Token格式');
      }

      // 紧急禁用危险域名调用
      throw new Error('API暂时禁用以修复安全问题');

      const response = await fetch('/testapi/payment/renewal_controller/confirm_recharge', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          card_key: cardCode,
          token: actualToken,
          idp: idp
        })
      });
      
      const data = await response.json();
      console.log('确认充值API响应:', data);
      
      // 根据实际返回格式判断：{"task_id":"b75ea02d-7892-4677-a7e6-2bf40f6fd290","success":true}
      if (response.ok && data && data.success === true && data.task_id) {
        console.log('任务提交成功，task_id:', data.task_id);
        return {
          success: true,
          data: {
            taskId: data.task_id,
            status: 'processing',
            message: '任务提交成功，开始处理续费'
          }
        };
      } else {
        console.log('任务提交失败:', data);
        return {
          success: false,
          message: data.message || data.error || '续费任务提交失败'
        };
      }
    } catch (error) {
      console.error('续费处理失败:', error);
      return {
        success: false,
        message: '续费处理失败，请检查网络连接'
      };
    }
  },

  // 查询续费状态
  checkStatus: async (taskId) => {
    try {
      // 紧急禁用危险域名调用
      throw new Error('API暂时禁用以修复安全问题');

      const response = await fetch(`/testapi/payment/renewal_controller/recharge_status?task_id=${taskId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      const data = await response.json();
      
      if (response.ok && data) {
        // 根据实际返回格式处理：{"status": "completed", "result": "任务处理成功"}
        console.log('查询状态API响应:', data);
        
        // 将status映射到前端期望的格式
        let frontendStatus = 'processing'; // 默认为处理中
        if (data.status === 'completed') {
          frontendStatus = 'success';  // completed -> success
        } else if (data.status === 'failed' || data.status === 'error') {
          frontendStatus = 'failed';
        }
        
        return {
          success: true,
          data: {
            status: frontendStatus,
            taskId: taskId,
            message: data.result || data.message || '状态查询成功',
            expiryDate: data.expiry_date || data.expiryDate
          }
        };
      } else {
        return {
          success: false,
          message: data.message || data.result || '查询状态失败'
        };
      }
    } catch (error) {
      console.error('查询续费状态失败:', error);
      return {
        success: false,
        message: '查询状态失败，请检查网络连接'
      };
    }
  },

  // 获取续费历史
  getRenewalHistory: async (email) => {
    try {
      const response = await api.get('/renewal/history', {
        params: { email }
      });
      return response.data;
    } catch (error) {
      console.error('获取续费历史失败:', error);
      throw error;
    }
  }
};

export default renewalAPI;